import { Stack, Typography } from '@mui/material';
import { _ } from '/@/locale';
import {
    GrowerHasNoFieldsEmptyState,
    MyFieldsEmptyState,
    NoFieldsForProductEmptyState,
    NoGrowersEmptyState,
} from './field-select-empty-states';
import FieldSelectListAndMap from './field-select-list-and-map';
import FieldSelectSkeletonList from './field-select-skeleton-list';
import type { FieldSelectState } from './use-field-select';

type FieldSelectMainContentProps = Pick<
    FieldSelectState,
    | 'tab'
    | 'hasNoGrowers'
    | 'isLoadingGrowers'
    | 'showMyFieldsEmpty'
    | 'showNoFieldsForProduct'
    | 'isLoadingFields'
    | 'fieldList'
    | 'debouncedFieldName'
    | 'isMobile'
    | 'handleAddField'
    | 'setNewFieldModalOpen'
    | 'setNewGrowersModalOpen'
    | 'field'
    | 'setField'
    | 'selectedProduct'
    | 'product'
    | 'showGrowersFields'
    | 'fieldRefs'
    | 'mapRef'
    | 'handleFieldClick'
    | 'fieldsQuery'
    | 'countryCode'
    | 'lastCampaigns'
>;

function FieldSelectMainContent({
    tab,
    hasNoGrowers,
    isLoadingGrowers,
    showMyFieldsEmpty,
    showNoFieldsForProduct,
    isLoadingFields,
    fieldList,
    debouncedFieldName,
    isMobile,
    handleAddField,
    setNewFieldModalOpen,
    setNewGrowersModalOpen,
    ...listAndMapProps
}: FieldSelectMainContentProps) {
    const openFieldModal = () => setNewFieldModalOpen(true);

    if (hasNoGrowers && tab === 'growers') {
        return isLoadingGrowers ? (
            <FieldSelectSkeletonList minHeight='500px' />
        ) : (
            <NoGrowersEmptyState onAddFields={openFieldModal} onOpenGrowersModal={() => setNewGrowersModalOpen(true)} />
        );
    }

    // Ahead of the "add a field" states: the fields exist, they are just outside this hybrid's
    // zones, so telling the user to add one would be wrong.
    if (showNoFieldsForProduct) {
        return <NoFieldsForProductEmptyState productName={listAndMapProps.product?.catalogName} />;
    }

    if (showMyFieldsEmpty) {
        return <MyFieldsEmptyState onAddFields={openFieldModal} onAddField={() => handleAddField()} />;
    }

    return (
        <Stack direction={isMobile ? 'column-reverse' : 'row'} width='100%' minHeight='500px'>
            {isLoadingFields ? (
                <FieldSelectSkeletonList />
            ) : !fieldList.length ? (
                !debouncedFieldName ? (
                    <GrowerHasNoFieldsEmptyState onAddFields={openFieldModal} onAddField={() => handleAddField()} />
                ) : (
                    <Stack width='100%' p={2}>
                        <Typography>{_('No se encontraron resultados para tu búsqueda.')}</Typography>
                    </Stack>
                )
            ) : (
                <FieldSelectListAndMap fieldList={fieldList} isMobile={isMobile} {...listAndMapProps} />
            )}
        </Stack>
    );
}

export default FieldSelectMainContent;
